<div class="not-found-wrapper">
  <div class="not-found-container">
    <div class="not-found-content">
      <div class="error-icon">
        <img src="../../assets/icons/plane.svg" alt="GradPilots" class="plane-icon">
      </div>
      <h1 class="error-code">404</h1>
      <h2 class="error-title">Page Not Found</h2>
      <p class="error-description">
        Oops! The page you're looking for seems to have taken off without us.
        Let's get you back on the right flight path.
      </p>
      <div class="error-actions">
        <button pButton class="home-button bg-primary" label="Go to Home" icon="pi pi-home" (click)="goToHome()">
        </button>
        <button pButton class="back-button" label="Go Back" icon="pi pi-arrow-left" (click)="goBack()">
        </button>
      </div>
    </div>
  </div>
</div>
